import ArrowBackIcon from "@mui/icons-material/ArrowBack";
import { Box, Button, Chip, Grid, Pagination, TextField, Typography, useMediaQuery } from "@mui/material";
import PageHeader from "../../components/ui/PageHeader";
import Section from "../../components/ui/Section";
import React, { useEffect, useState } from "react";
import { useDispatch } from "react-redux";
import { useLocation, useNavigate, useParams } from "react-router-dom";
import Layout from "../../components/Layout";
import { AppDispatch } from "../../redux/store";
import { getAllBreefsOfUser } from "../../service/BreefService";
import { getAllTeamsOfUser } from "../../service/teamService";
import { useUpdateUserForm } from "../../utils/forms";
import BreefTable, { Result } from "./UserBreefTable";
import { useTranslation } from "react-i18next";
import { getParticipantById } from "../../service/NewInvitedUser";
import { getTenantTwoFactor, resetTenantTwoFactor } from "../../service/UserService";
import Accordion from "@mui/material/Accordion";
import AccordionSummary from "@mui/material/AccordionSummary";
import AccordionDetails from "@mui/material/AccordionDetails";
import ExpandMoreIcon from "@mui/icons-material/ExpandMore";
import { TeamResult } from "./UserTeamTable";
import { giveFreeDays } from "../../service/SubscriptionService";
import { showSuccessToast } from "../../utils/Toast";

const UpdateViewEditUsers = () => {
  const [t] = useTranslation("global");
  const location = useLocation();
  const params = useParams();
  const { userId: userIdFromList, record: recordFromList } = location.state || "";
  // Id'et står også i adressen, så siden virker ved genindlæsning og direkte link
  const userId = userIdFromList || params.userId;
  // Uden state (genindlæsning eller direkte link) hentes deltageren selv
  const [fetched, setFetched] = useState<any>(null);
  const record = recordFromList || fetched;
  const isEdit = new URLSearchParams(location.search).get("isEdit");
  const isMobile = useMediaQuery("(max-width:600px)");
  const formik = useUpdateUserForm(!!isEdit, userId || "", isMobile);
  const [freeDays, setFreeDays] = useState("14");
  const [twoFactor, setTwoFactor] = useState<{ enabled: boolean; method?: string } | null>(null);
  const [resettingTwoFactor, setResettingTwoFactor] = useState(false);
  useEffect(() => {
    if (userId) getTenantTwoFactor(String(userId)).then(setTwoFactor);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [userId]);
  const [givingDays, setGivingDays] = useState(false);
  const [freeDaysResult, setFreeDaysResult] = useState<{ days: number; nextPayment: string | null; freeUntil: string } | null>(null);
  const [isEditing, setIsEditing] = useState(isEdit === "true");
  const [filteredData, setFilteredData] = useState<Result[]>([]);
  const [teamData, setTeamData] = useState<TeamResult[]>([]);

  const [teamCurrentPage] = useState(1);
  const [breefCurrentPage, setBreefCurrentPage] = useState(1);
  const [pageLimit] = useState(10);
  const [totalPages] = useState(0);
  const [totalResults] = useState(0);
  const [rowsPerPage] = useState(10);
  const navigate = useNavigate();
  const dispatch: AppDispatch = useDispatch();

  const fetchBreefs = async (pageNo: number) => {
    const data = await getAllBreefsOfUser(dispatch, isMobile, navigate, userId, pageLimit, pageNo);
    if (data) {
      console.log("Data: ", data);

      setFilteredData(data.results);
    }
  };

  const fetchTeams = async (pageNo: number) => {
    const data = await getAllTeamsOfUser(isMobile, navigate, userId, pageNo, rowsPerPage);
    if (data) {
      console.log("Team Data: ", data);

      setTeamData(data.teamNames);
    }
  };

  useEffect(() => {
    if (!recordFromList && userId) getParticipantById(userId).then(setFetched);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [userId]);

  useEffect(() => {
    console.log("Fetchign data");

    if (userId) {
      fetchBreefs(breefCurrentPage);
      fetchTeams(teamCurrentPage);
    }
  }, [userId, teamCurrentPage, breefCurrentPage]);

  useEffect(() => {
    console.log("teamData:", teamData);
  }, [teamData]);
  const handleBreefPageChange = (event: React.ChangeEvent<unknown>, value: number) => {
    console.log("page val: ", value);

    setBreefCurrentPage(value);
  };

  const handleSubmit = async (e: React.FormEvent<HTMLFormElement>) => {
    e.preventDefault();
    try {
      // const data = {
      //   firstName: formik.values.firstName,
      //   lastName: formik.values.lastName,
      // };
      // await updateAdminDashUser(userId, data);
      console.log("handle submit called");

      formik.handleSubmit();
      // setIsEditing(false);
    } catch (err) {
      console.error("Error editing user details: ", err);
    }
  };

  const handleCancel = () => {
    setIsEditing(false);
    navigate("/manage-users");
  };

  const setUptenant = () => {
    formik.setValues({
      firstName: record?.firstName,
      lastName: record?.lastName,
      password: "",
      email: record?.email,
      phoneNo: record?.phoneNumber,
      totalScore: record?.totalScore,
    });
  };
  useEffect(() => {
    setUptenant();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [userId, isEdit, record]);

  return (
    <Layout>
      <PageHeader
        title={`${isEdit === "true" ? t("common.edit") : t("common.view")} ${t("updateUser.t1")}: ${record?.firstName || ""} ${record?.lastName || ""}`}
        actions={
          <Button onClick={handleCancel} startIcon={<ArrowBackIcon />}>
            {t("common.back")}
          </Button>
        }
      />
      <Section title={t("updateUser.contact")}>
        <Box component="form" onSubmit={handleSubmit}>
          <Grid container spacing={2}>
            <Grid item xs={12} sm={6}>
              <TextField
                autoFocus
                required
                margin="dense"
                id="firstName"
                name="firstName"
                InputLabelProps={{ shrink: true }}
                label={t("updateTenant.t2")}
                type="text"
                fullWidth
                variant="outlined"
                onChange={formik.handleChange("firstName")}
                value={formik.values.firstName}
                error={formik.touched.firstName && Boolean(formik.errors.firstName)}
                helperText={formik.touched.firstName && formik.errors.firstName}
                disabled={!isEditing}
              />
            </Grid>
            <Grid item xs={12} sm={6}>
              <TextField
                required
                margin="dense"
                id="lastName"
                name="lastName"
                InputLabelProps={{ shrink: true }}
                label={t("updateTenant.t3")}
                type="text"
                fullWidth
                variant="outlined"
                onChange={formik.handleChange("lastName")}
                value={formik.values.lastName}
                error={formik.touched.lastName && Boolean(formik.errors.lastName)}
                helperText={formik.touched.lastName && formik.errors.lastName}
                disabled={!isEditing}
              />
            </Grid>
            <Grid item xs={12} sm={6}>
              <TextField
                margin="dense"
                id="totalScore"
                name="totalScore"
                InputLabelProps={{ shrink: true }}
                label={t("manageUsers.t13")}
                type="text"
                fullWidth
                variant="outlined"
                onChange={formik.handleChange("totalScore")}
                value={formik.values.totalScore}
                error={formik.touched.totalScore && Boolean(formik.errors.totalScore)}
                helperText={formik.touched.totalScore && formik.errors.totalScore}
                disabled={!isEditing}
              />
            </Grid>
          {/* </Grid> */}
          {/* <Grid container spacing={2}> */}
            <Grid item xs={12} sm={6}>
              <TextField
                margin="dense"
                id="phoneNumber"
                name="phoneNumber"
                label={t("updateTenant.t5")}
                type="text"
                fullWidth
                variant="outlined"
                onChange={formik.handleChange("phoneNo")}
                value={formik.values.phoneNo}
                error={formik.touched.phoneNo && Boolean(formik.errors.phoneNo)}
                helperText={formik.touched.phoneNo && formik.errors.phoneNo}
                disabled
              />
            </Grid>
         
          </Grid>
          <Box sx={{ mt: 2, display: "flex", justifyContent: "flex-end" }}>
            {isEditing && (
              <>
                <Button
                  onClick={handleCancel}
                  variant="outlined"
                  sx={{
                    mr: 1,
                    "&:hover": { borderColor: "#d55a07" },
                  }}
                >
                  {t("updateTenant.t6")}
                </Button>
                <Button
                  type="submit"
                  variant="contained"
                  sx={{ "&:hover": { backgroundColor: "#d55a07" } }}
                >
                  {t("updateTenant.t7")}
                </Button>
              </>
            )}
          </Box>
        </Box>
      </Section>
      {/* Two-factor login is the customer's own choice in the portal; support only turns it off for a customer who
          lost the phone. The customer gets a mail about it, and it goes in the audit log. */}
      <Section title={t("tenantTwoFactor.title")}>
        <Typography variant="body2" color="text.secondary" sx={{ mb: 2 }}>
          {twoFactor === null ? t("tenantTwoFactor.unknown") : twoFactor.enabled ? t("tenantTwoFactor.on", { method: t(`tenantTwoFactor.method_${twoFactor.method || "app"}`) }) : t("tenantTwoFactor.off")}
        </Typography>
        {twoFactor?.enabled && (
          <Button
            variant="outlined"
            color="error"
            disabled={resettingTwoFactor}
            onClick={async () => {
              if (!window.confirm(t("tenantTwoFactor.confirm"))) return;
              setResettingTwoFactor(true);
              const ok = await resetTenantTwoFactor(String(userId), false);
              setResettingTwoFactor(false);
              if (ok) {
                showSuccessToast(t("tenantTwoFactor.done"), false);
                setTwoFactor({ enabled: false });
              }
            }}
          >
            {t("tenantTwoFactor.reset")}
          </Button>
        )}
      </Section>
      {/* Gratis dage: flytter den næste betaling i Stripe, så kunden ikke trækkes før den nye dato.
          Der spørges om en begrundelse, og hvem der gav hvad til hvem står i revisionsloggen. */}
      <Section title={t("freeDays.title")}>
        <Typography variant="body2" color="text.secondary" sx={{ mb: 2 }}>
          {t("freeDays.intro")}
        </Typography>
        <Box sx={{ display: "flex", gap: 2, alignItems: "center", flexWrap: "wrap" }}>
          <TextField
            size="small"
            type="number"
            label={t("freeDays.days")}
            inputProps={{ min: 1, max: 365 }}
            value={freeDays}
            onChange={(event) => setFreeDays(event.target.value)}
            sx={{ width: 140 }}
          />
          <Button
            variant="contained"
            disabled={givingDays || !Number(freeDays)}
            onClick={async () => {
              setGivingDays(true);
              const result = await giveFreeDays(String(userId), Number(freeDays));
              setGivingDays(false);
              if (result) {
                setFreeDaysResult(result);
                showSuccessToast(t("freeDays.given", { days: result.days }), false);
              }
            }}
          >
            {t("freeDays.give")}
          </Button>
          {freeDaysResult && (
            <Typography variant="body2">
              {freeDaysResult.nextPayment
                ? t("freeDays.nextPayment", { date: new Date(freeDaysResult.nextPayment).toLocaleDateString("da-DK") })
                : t("freeDays.accessUntil", { date: new Date(freeDaysResult.freeUntil).toLocaleDateString("da-DK") })}
            </Typography>
          )}
        </Box>
      </Section>

      <Section title={t("nav.t11")}>
        {teamData === null ? (
          <Typography variant="body2" color="text.secondary">{t("common.loading")}</Typography>
        ) : teamData.length > 0 ? (
          <Box sx={{ display: "flex", gap: 1, flexWrap: "wrap" }}>
            {teamData.map((team: any) => (
              <Chip key={team.id} label={team.teamName} />
            ))}
          </Box>
        ) : (
          <Typography variant="body2" color="text.secondary">{t("updateUser.noTeams")}</Typography>
        )}
      </Section>

      <Section title={t("updateUser.breefs")}>
        <BreefTable results={filteredData} page={breefCurrentPage} limit={pageLimit} totalPages={totalPages} totalResults={totalResults} />
        <Box sx={{ display: "flex", justifyContent: "center", my: 2, alignItems: "center" }}>
          <Pagination count={totalPages + 2} page={breefCurrentPage} onChange={handleBreefPageChange} />
        </Box>
      </Section>
    </Layout>
  );
};

export default UpdateViewEditUsers;
